export * from './DetailsModal'

export const MODAL_LEAD_DETAILS = 'MODAL_LEAD_DETAILS'
